// extracted by mini-css-extract-plugin
export default {"tabs_list":"index_tabs_list_dSpV2 clearfix","tabsItem":"index_tabsItem_d0zHK"};